export default "__VITE_ASSET__uN9nGYkc__"